const activeEventReducer = (
    state = false,
    action
  ) => {
    switch (action.type) {
      case "SET_ACTIVE_EVENT":
        return action.activeEvent;
      default:
        return state;
    }
  };
  
  export default activeEventReducer;
  